import { createTickerMessageComponent } from '@modules/src/ticker/createTickerMessageComponent'
import { Orientation } from '@modules/src/enums/Orientation'
import { ComponentEvent } from '@modules/src/enums/ComponentEvent'
import { TranslationUtils } from '@modules/src/utils/TranslationUtils'
import GameSignals from '@/signals/GameSignals'

const resolveIdleMessage = () => {
    const translated = TranslationUtils.translate('uiText1')
    return translated === 'uiText1' ? 'Click SPIN to play' : translated
}

const formatWinAmount = (rawWinAmount: number): string => {
    if (!Number.isFinite(rawWinAmount)) {
        return '0.00'
    }

    return (rawWinAmount / 100).toFixed(2)
}

export const TICKER_MESSAGE_COMPONENT = createTickerMessageComponent({
    name: 'TickerMessageContainer',
    textName: 'TickerMessageText',
    zIndex: new Map<Orientation, number>([
        [Orientation.LANDSCAPE, 420],
        [Orientation.PORTRAIT, 420],
    ]),
    signals: {
        // The real intro->base completion in this game is completeTransitionAnimation.
        completeSplashScreenState: GameSignals.completeTransitionAnimation,
        idle: GameSignals.idle,
        startSpin: GameSignals.startSpin,
        showRegularWin: GameSignals.showRegularWin,
    },
    resolveIdleMessage,
    spinStartMessage: 'Good Luck!',
    winningComboPrefix: 'Winning Combo',
    winningComboDelaySec: 1,
    position: [
        { orientation: Orientation.LANDSCAPE, x: 140.5, y: 752 },
        { orientation: Orientation.PORTRAIT, x: 396.5, y: 1264.5 },
    ],
    textStyle: [
        {
            orientation: Orientation.ANY,
            options: {
                fill: '#41fe00',
                fontFamily: 'StagSansRound',
                fontSize: 32,
                fontWeight: '700',
                align: 'center',
                letterSpacing: 2,
                stroke: '#0d3020',
                strokeThickness: 12,
                dropShadow: true,
                dropShadowColor: '#202020',
                dropShadowDistance: 4,
                dropShadowBlur: 3,
                maxWidth: 550,
            },
        },
    ],
    formatWinAmount,
    overrides: {
        container: {
            events: [
                {
                    event: ComponentEvent.SHOW,
                    onGameSignalsTriggered: [
                        GameSignals.completeTransitionAnimation,
                        GameSignals.showBaseGameBackground,
                    ],
                },
                {
                    event: ComponentEvent.HIDE,
                    onGameSignalsTriggered: [
                        GameSignals.displaySplashScreenState,
                        GameSignals.splashScreenButtonClicked,
                        GameSignals.bonusStart,
                        GameSignals.bonusStop,
                    ],
                },
            ],
        },
    },
})
